import domReady from '@wordpress/dom-ready';
import { createRoot, render } from '@wordpress/element';
import DemoCards from './DemoCards';

domReady( () => {
	const demoCards = document.querySelectorAll(
		'.wp-block-do-blocks-demo-cards'
	);

	if ( demoCards.length > 0 ) {
		demoCards.forEach( ( demoCard ) => {
			if ( createRoot ) {
				createRoot( demoCard ).render( <DemoCards /> );
			} else {
				render( <DemoCards />, demoCard );
			}
		} );
	}
} );
